'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _IconButton = require('../../IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _checkbox_active = require('../img/checkbox_active.svg');

var _checkbox_active2 = _interopRequireDefault(_checkbox_active);

var _checkbox = require('../img/checkbox.svg');

var _checkbox2 = _interopRequireDefault(_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var label = null,
        classList = this.compileStyle(_index2.default),
        img = void 0,
        _props$theme = this.props.theme,
        theme = _props$theme === undefined ? {} : _props$theme,
        palette = theme.palette || theme,
        icon = void 0;
    var _props = this.props,
        disabled = _props.disabled,
        id = _props.id,
        name = _props.name,
        checked = _props.checked,
        value = _props.value,
        attribute = _props.attribute;


    if (this.props.children) {
        label = _react2.default.createElement(
            'div',
            { className: classList.labelText },
            this.props.children
        );
    } else {
        label = _react2.default.createElement(
            'div',
            { className: classList.labelText },
            this.props.label
        );
    }

    if (checked) {
        img = this.props.checkedIcon || theme.appearanceChecked || _checkbox_active2.default;
    } else {
        img = this.props.icon || theme.appearance || _checkbox2.default;
    }

    if (typeof img === 'string') {
        icon = _react2.default.createElement(_IconButton2.default, {
            icon: img,
            iconFx: !checked,
            rippleColor: checked ? palette.elAccent : undefined,
            disabled: disabled
        });
    } else {
        icon = img;
    }

    return _react2.default.createElement(
        'div',
        { className: classList.root + ' ' + (this.props.className || '') },
        _react2.default.createElement('input', {
            onChange: this.props.onChange,
            disabled: disabled,
            checked: !!checked,
            value: value,
            id: id || this.state.id,
            name: name,
            type: 'checkbox',
            className: classList.field,
            ref: this._createRef.bind(this),
            'data-qa-node': attribute,
            'data-qa-value': !!checked
        }),
        _react2.default.createElement(
            'label',
            { className: classList.label, htmlFor: id || this.state.id },
            _react2.default.createElement(
                'div',
                { className: classList.iconWrapper },
                icon
            ),
            label
        )
    );
}